import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaicabservice() {



  const cardData =
  {
    keyword: 'Mumbai Cab Service ',
    heading: 'Shambhu Cabs: Mumbai Cab Service',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai Cab Service, providing safe, comfortable, and convenient transportation for daily commuters, corporate travelers, families, and tourists across the city. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures smooth travel for airport transfers, local sightseeing, office commutes, and outstation trips. With professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and flexible booking options, Shambhu Cabs delivers a seamless and hassle-free travel experience. Whether it’s short city rides or long journeys, Shambhu Cabs is your trusted choice for dependable and comfortable cab service in Mumbai..',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch constructed to honor the visit of King George V and Queen Mary. Overlooking the Arabian Sea, the monument stands as a grand symbol of colonial heritage. Tourists enjoy ferry rides to Elephanta Island, coastal photography, and the bustling street market nearby. Evenings at the Gateway are magical, with soft lighting, sea breeze, and a lively atmosphere created by performers, food vendors, and travelers from around the world."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s stunning 3.6 km-long curved boulevard along the Arabian Sea. The street lights at night resemble a 'Queen’s Necklace,' making it one of the most beautiful coastlines in India. Ideal for morning walks, jogging, cycling, and sunset viewing, Marine Drive offers a peaceful escape from city life. The Art Deco buildings lining the road add heritage value, forming one of the world’s largest Art Deco collections. The sea breeze, scenic views, and relaxing vibe make it a must-visit."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT is a UNESCO World Heritage Site and an architectural masterpiece built in 1887. A blend of Victorian Gothic Revival and traditional Indian styles, its grand domes, stained glass windows, carvings, and high arches attract architecture and history lovers. One of India’s busiest railway stations, it stands as a symbol of Mumbai’s bustling life. At night, the building is illuminated beautifully, making it one of the most photographed landmarks in the city."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beachfront, famous for its lively atmosphere, delicious street food, and colorful sunsets. Visitors enjoy local favorites like pav bhaji, pani puri, bhel puri, and ice gola. Kids love camel rides, horse rides, and kite flying, while Bollywood fans often spot celebrities who live nearby. The energetic yet relaxing ambiance makes Juhu Beach a perfect place for evening strolls, photography, and enjoying Mumbai’s coastal charm."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, known for fulfilling wishes. The wooden doors feature Ashtavinayak carvings, and the gold-plated inner sanctum adds to its divine aura. Thousands visit daily, including film stars, sports personalities, and political leaders. During Ganesh Chaturthi, the temple area transforms into a vibrant cultural and devotional celebration filled with music, lights, chants, and festive energy."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on a tiny islet connected by a narrow causeway, is one of Mumbai’s most spiritual and picturesque landmarks. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it showcases Indo-Islamic architecture with its stunning white marble structure. Visitors walk along the pathway during low tide to reach the dargah. The peaceful ambiance, soulful qawwalis, and panoramic sea views make it a deeply moving experience for people of all faiths."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, located on Elephanta Island, are ancient rock-cut caves and a UNESCO World Heritage Site dating back to the 5th–8th centuries. Dedicated mainly to Lord Shiva, the caves feature breathtaking sculptures such as the Trimurti (three-faced Shiva), Nataraja, and various mythological carvings. Visitors take a ferry from the Gateway of India, enjoying sea views, monkeys, local food stalls, and a peaceful island atmosphere filled with history and art."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is an iconic cable-stayed bridge connecting Mumbai’s western suburbs to South Mumbai. It is celebrated for its modern engineering, graceful architecture, and stunning views of the sea and skyline. The bridge reduces travel time and offers breathtaking sights during sunrise, sunset, and nighttime when the structure glows with lights. Although stopping on the bridge isn’t allowed, it remains a favorite landmark for photographers and travelers."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar is one of India’s oldest and most fascinating flea markets, known for antiques, vintage décor, Bollywood posters, gramophones, lamps, furniture, cameras, and rare collectibles. Every visit feels like a treasure hunt, with lanes filled with quirky items and historical remnants. The market attracts photographers, designers, and collectors seeking unique artifacts. It offers a glimpse into Mumbai’s old charm, trade culture, and hidden stories from the past."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread over 100 square kilometers, Sanjay Gandhi National Park is a lush green paradise within Mumbai. Home to leopards, deer, birds, butterflies, and ancient Kanheri Caves, the park offers nature trails, cycling routes, boating, safari rides, and scenic viewpoints. The Kanheri Caves, carved out of basalt rock, feature Buddhist sculptures, meditation halls, and monasteries dating back thousands of years. The park serves as a peaceful escape from the busy city."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is one of Mumbai’s oldest and most beautiful Roman Catholic churches. Built in stunning Gothic style, it overlooks the sea and offers a calm, spiritual environment. The annual Bandra Fair brings thousands of visitors who enjoy food stalls, festivities, and cultural performances. The church is a symbol of faith, unity, and Mumbai’s diverse religious culture."
  }
],



"services": [
  {
    "name": "Cab Service Mumbai",
    "description": "Cab Service Mumbai provides reliable, fast, and comfortable travel solutions across the entire city, covering suburbs, business districts, residential zones, and major travel hubs. With clean AC cabs, trained chauffeurs, and transparent pricing, this service ensures smooth point-to-point travel at any hour. Whether you're commuting for work, attending meetings, visiting family, or exploring the city, the service delivers a safe, efficient, and hassle-free travel experience. Ideal for daily rides, emergency travel, and routine city transportation."
  },
  {
    "name": "Taxi Service Mumbai",
    "description": "Taxi Service Mumbai offers dependable citywide taxi solutions for individuals, families, and corporate travellers. With quick response times, accessible booking options, and professional drivers, this service ensures effortless mobility throughout Mumbai. Passengers enjoy timely pickups, comfortable interiors, and smooth rides across traffic-heavy routes. Designed for regular commuters, tourists, and business professionals, this service guarantees a stress-free travel experience anywhere in the city."
  },
  {
    "name": "Car Rental Mumbai",
    "description": "Car Rental Mumbai provides a wide assortment of rental vehicles, including sedans, SUVs, hatchbacks, and premium cars suitable for local and outstation travel. With chauffeur-driven options and flexible hourly, daily, weekly, and monthly plans, customers enjoy convenience and affordability. Perfect for corporate usage, family outings, airport transfers, and personalized travel, this service ensures clean cars, reliable drivers, and comfortable citywide mobility."
  },
  {
    "name": "Local Cab Mumbai",
    "description": "Local Cab Mumbai offers quick and affordable rides for everyday travel within the city. This service is ideal for shopping trips, office commutes, local sightseeing, appointments, and neighbourhood travel. With 24×7 availability, easy booking, courteous drivers, and sanitized AC cars, the service is designed to simplify daily commuting for all age groups. The focus remains on convenience, safety, and punctuality."
  },
  {
    "name": "Mumbai Airport Cab",
    "description": "Mumbai Airport Cab provides smooth and timely airport pickups and drops from both T1 and T2 terminals. The service ensures punctuality, clean vehicles, and trained chauffeurs who understand flight timings, delays, and terminal navigation. Suitable for business travellers, families, tourists, and corporate professionals, the airport cab guarantees stress-free travel with ample luggage space and round-the-clock availability."
  },
  {
    "name": "Affordable Cab Mumbai",
    "description": "Affordable Cab Mumbai is designed for budget-conscious travellers seeking cost-effective taxi options without compromising on comfort or safety. Clean AC cars, experienced drivers, and transparent pricing make this service ideal for short rides, frequent commutes, and long travel hours. Customers can enjoy dependable transportation at pocket-friendly rates across Mumbai."
  },
  {
    "name": "Premium Taxi Mumbai",
    "description": "Premium Taxi Mumbai offers a higher level of comfort with luxury sedans and SUVs, top-quality interiors, and professionally trained chauffeurs. Perfect for corporate executives, business meetings, airport transfers, and special events, this service ensures a smooth and elevated travel experience. Amenities may include leather seating, premium AC comfort, bottled water, and neat presentation."
  },
  {
    "name": "24×7 Cab Service",
    "description": "24×7 Cab Service ensures round-the-clock availability for early-morning, late-night, emergency, or scheduled travel across Mumbai. Designed for maximum convenience, this service guarantees quick response times, safe night travel, and reliable cars throughout the day. It is ideal for airport pickups, office shifts, hospital visits, and urgent trips."
  },
  {
    "name": "Sedan Cab Mumbai",
    "description": "Sedan Cab Mumbai offers smooth, comfortable, and fuel-efficient rides ideal for small families, solo passengers, and business travellers. Sedans like Dzire, Etios, and Honda City provide good legroom, AC comfort, stable driving, and affordability. Suitable for both short and long rides, this service is known for reliability and comfort."
  },
  {
    "name": "SUV Cab Mumbai",
    "description": "SUV Cab Mumbai provides spacious, powerful, and comfortable travel for families and groups. Vehicles like Ertiga, Innova, and Crysta offer superior comfort, steady long-distance performance, and extra luggage capacity. It is ideal for outstation trips, airport transfers, and group travel requiring additional room and stability."
  },
  {
    "name": "Outstation Cab Mumbai",
    "description": "Outstation Cab Mumbai delivers reliable long-distance travel for one-way, round trip, and multi-city journeys. The service offers a variety of cars, highway-trained chauffeurs, and transparent fares for comfortable interstate or intrastate travel. Perfect for holiday trips, weekend getaways, business tours, and family travel."
  },
  {
    "name": "Corporate Cab Service Mumbai",
    "description": "Corporate Cab Service Mumbai provides professional transport solutions for companies, IT firms, and business organizations. With punctual drivers, clean vehicles, and month-end billing support, the service is ideal for staff pickups, client travel, office commute programs, and executive taxis. Designed to offer reliability, safety, and efficiency for corporate travellers."
  },
  {
    "name": "Fast Cab Booking Mumbai",
    "description": "Fast Cab Booking Mumbai offers quick and hassle-free cab reservations with minimal waiting time. Ideal for urgent travel needs, this service ensures fast dispatch, immediate availability, and smooth navigation through Mumbai’s busy routes. Perfect for commuters needing instant travel assistance."
  },
  {
    "name": "Online Taxi Mumbai",
    "description": "Online Taxi Mumbai provides digital booking convenience through mobile and web platforms, enabling easy reservations, live tracking, and advance scheduling. Customers enjoy transparent fares, multiple vehicle choices, and instant confirmation. This service enhances convenience and reliability across city and outstation travel needs."
  },
  {
    "name": "AC Cab Service Mumbai",
    "description": "AC Cab Service Mumbai ensures cool, comfortable, and hygienic rides across the city. Ideal for daily commuting, city tours, or long travel, every vehicle features well-maintained air conditioning, clean interiors, and professional drivers. This service is popular during summers and long-duration rides."
  },
  {
    "name": "Pickup Drop Cab Mumbai",
    "description": "Pickup Drop Cab Mumbai provides seamless door-to-door travel for office commutes, school runs, airport transfers, and routine movement across the city. The service is punctual, safe, and suitable for all types of travellers including seniors, children, and working professionals."
  },
  {
    "name": "Best Cab Operators Mumbai",
    "description": "Best Cab Operators Mumbai brings together trusted and verified cab providers offering reliable service quality, well-maintained cars, and experienced drivers. These operators specialize in local travel, airport rides, corporate bookings, and outstation journeys. Known for consistent service, transparent pricing, and customer-focused operations, they deliver dependable transportation across Mumbai."
  }
],

"tableData": [
  ["Cab Service Mumbai", "Taxi Service Mumbai"],
  ["Car Rental Mumbai", "Local Cab Mumbai"],
  ["Mumbai Airport Cab", "Affordable Cab Mumbai"],
  ["Premium Taxi Mumbai", "24×7 Cab Service"],
  ["Sedan Cab Mumbai", "SUV Cab Mumbai"],
  ["Outstation Cab Mumbai", "Corporate Cab Service Mumbai"],
  ["Fast Cab Booking Mumbai", "Online Taxi Mumbai"],
  ["AC Cab Service Mumbai", "Pickup Drop Cab Mumbai"],
  ["Best Cab Operators Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai Cab Service with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable and affordable Mumbai cab services, perfect for city travel, airport transfers, daily commutes, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Enjoy traveling in spacious, air-conditioned, and regularly serviced cars that ensure a smooth and comfortable ride anywhere in Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our skilled and courteous drivers are familiar with all major Mumbai routes, ensuring safe, timely, and stress-free travel experiences."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We offer clear and upfront pricing with no hidden charges—making your Mumbai cab service completely reliable and budget-friendly."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route guidance, and all your travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from hourly rentals, full-day cabs, airport transfers, and customized packages tailored to your Mumbai travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Cabs",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic travel experience throughout Mumbai."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your travel within Mumbai convenient, comfortable, and stress-free."
  }
]























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab services in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services across Mumbai, including local travel, airport transfers, and outstation journeys.',
  },
  {
    question: 'How can I book a cab in Mumbai with Shambhu Cabs?',
    answer: 'You can easily book a cab through our website, mobile app, or by contacting our 24x7 customer support team for a smooth and hassle-free experience.',
  },
  {
    question: 'What types of cabs are available for booking in Mumbai?',
    answer: 'Shambhu Cabs offers a wide range of vehicles including sedans, SUVs, luxury cars, and tempo travellers for all your travel needs in Mumbai.',
  },
  {
    question: 'Are the drivers experienced for Mumbai cab services?',
    answer: 'Yes, all our drivers are licensed, professional, and familiar with Mumbai’s roads to ensure a safe, efficient, and comfortable journey.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for my cab booking in Mumbai?',
    answer: 'Yes, you can specify any pickup and drop-off points within Mumbai for a convenient and personalized travel experience.',
  },
  {
    question: 'Is Mumbai cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock cab services in Mumbai, so you can travel whenever it suits your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai cab services?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict hygiene and safety measures to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for all cab bookings in Mumbai.',
  },
  {
    question: 'Is customer support available during Mumbai cab journeys?',
    answer: 'Yes, Shambhu Cabs provides 24x7 customer support to assist you during your entire cab journey within Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Iyer',
    feedback: 'The Mumbai cab service from Shambhu Cabs was fantastic! The booking was easy, the car was clean and comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Simran Sharma',
    feedback: 'I’ve used Shambhu Cabs for multiple trips around Mumbai. Their service is always punctual, safe, and reliable. Highly recommend!',
    rating: 5,
  },
];







































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-cab-service.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai cab services including local rides, airport transfers, corporate travel, outstation trips, and luxury sedan and SUV cabs, available 24×7.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-cab-service"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai Cab Service | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book reliable Mumbai cab services with Shambhu Cabs. Affordable local, airport, outstation, corporate, and premium cab services with sedans and SUVs available 24×7."
  />

  <meta
    name="keywords"
    content="Cab Service Mumbai, Taxi Service Mumbai, Car Rental Mumbai, Local Cab Mumbai, Mumbai Airport Cab, Affordable Cab Mumbai, Premium Taxi Mumbai, 24×7 Cab Service, Sedan Cab Mumbai, SUV Cab Mumbai, Outstation Cab Mumbai, Corporate Cab Service Mumbai, Fast Cab Booking Mumbai, Online Taxi Mumbai, AC Cab Service Mumbai, Pickup Drop Cab Mumbai, Best Cab Operators Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaicabservice;